import { render, staticRenderFns } from "./DialogViewALink.vue?vue&type=template&id=1c6b3112&scoped=true"
import script from "./DialogViewALink.vue?vue&type=script&lang=js"
export * from "./DialogViewALink.vue?vue&type=script&lang=js"
import style0 from "./DialogViewALink.vue?vue&type=style&index=0&id=1c6b3112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6b3112",
  null
  
)

export default component.exports